import { render, staticRenderFns } from "./Instruments.vue?vue&type=template&id=cd048f38&scoped=true"
import script from "./Instruments.vue?vue&type=script&lang=js"
export * from "./Instruments.vue?vue&type=script&lang=js"
import style0 from "./Instruments.vue?vue&type=style&index=0&id=cd048f38&prod&lang=scss&scoped=true"
import style1 from "./Instruments.vue?vue&type=style&index=1&id=cd048f38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd048f38",
  null
  
)

export default component.exports